<!-- Wrapper com altura definida + canvas "nu": padrão recomendado do Chart.js para
	render nítido (responsive + maintainAspectRatio:false dimensionam o buffer ao container). -->
<div class="chart-canvas" [style.height.px]="Height">
	<canvas #canvasChart></canvas>
</div>
